module.exports = __webpack_public_path__ + "img/cancercouncil-tas.6bad607.png";